export enum VaultContractTypeEnum {
    main = 'main',
    receiver = 'receiver',
}
